// extracted by mini-css-extract-plugin
module.exports = {"paypalButton":"_2kykp9","paypalBtn":"_2qgDJu","shine-lines":"_29P86l"};